export const MEDIA_SAVING = "MEDIA_SAVING";
export const MEDIA_SAVED = "MEDIA_SAVED";
export const MEDIA_SAVE_ERROR = "MEDIA_SAVE_ERROR";
export const MEDIA_RESET = "MEDIA_RESET";

